import gql from 'graphql-tag';

export default gql`
query getPropertyCurrencies {
    getPropertyCurrencies
}
`
